import { ReactElement } from 'react'
import Typography from '@mui/material/Typography'
import useStyles from './useStyles'

function ErrorIndicator(): ReactElement {
  const classes = useStyles()
  const message =
    'Se ha producido un error interno. Estamos trabajando para resolverlo lo antes posible.'
  return (
    <div className={classes.wrapper}>
      <Typography color="error">{message}</Typography>
    </div>
  )
}

export default ErrorIndicator
